import { render, staticRenderFns } from "./newshuo.vue?vue&type=template&id=b68f9b76"
import script from "./newshuo.vue?vue&type=script&lang=js"
export * from "./newshuo.vue?vue&type=script&lang=js"
import style0 from "./newshuo.vue?vue&type=style&index=0&id=b68f9b76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports